var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ExampleMessage"},[_vm._t("default"),_c('div',{staticClass:"ExampleMessage_Links"},_vm._l((_vm.sources),function(source){return _c('SourceLink',{key:source,attrs:{"sourcePath":source}})}),1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }